import { get } from "react-hook-form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { isApiErrorBody } from "@shared-kernel/domain/errors/api-error";

type ApiFieldErrorTarget<T extends FieldValues> = Pick<UseFormReturn<T>, "setError" | "getValues">;

// Affiche le detail d'un refus de l'API sous les champs qu'elle désigne, et focalise le premier ; RHF l'efface dès que le
// champ est corrigé. Rapprochement au mieux : les chemins de l'API (notation à points) sont ceux du body, donc ceux du
// formulaire quand il a sa forme ; renames traduit ceux qu'un mapper renomme. Un chemin absent du formulaire est ignoré
// (le toast porte déjà le detail), avant le focus, pour que celui-ci tombe sur le premier champ réellement affiché
export const applyApiFieldErrors = <T extends FieldValues>(
  form: ApiFieldErrorTarget<T>,
  error: unknown,
  renames: Readonly<Partial<Record<string, Path<T>>>> = {},
) => {
  if (!isApiErrorBody(error) || !error.detail) return;
  const message = error.detail;
  const values = form.getValues();
  error.fields
    // Chemin venu de l'API, vérifié juste après contre les valeurs du formulaire
    .map(field => renames[field] ?? (field as Path<T>))
    .filter(path => get(values, path) !== undefined)
    .forEach((path, index) => form.setError(path, { type: "server", message }, { shouldFocus: index === 0 }));
};
